import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e599b85c")

_pushScopeId("data-v-e599b85c")
const _hoisted_1 = { class: "outer-wrapper" }
const _hoisted_2 = {
  class: "wrapper",
  ref: "gridContainer"
}
const _hoisted_3 = { class: "algorithm-info has-text-centered" }
const _hoisted_4 = {
  class: "is-flex",
  style: {"flex-direction":"column","align-items":"center"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "Diagonal Movement", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "has-text-weight-bold" }, "Visualizing", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "has-text-weight-bold" }, "Algo Speed", -1)
const _hoisted_8 = { class: "is-flex" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Unvisited Node ")
const _hoisted_10 = {
  class: "is-flex",
  style: {"margin-top":"5px"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Wall Node ")
const _hoisted_12 = { class: "is-flex" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Open Node ")
const _hoisted_14 = {
  class: "is-flex",
  style: {"margin-top":"5px"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Closed Node ")
const _hoisted_16 = { class: "is-flex" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Final Path ")
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "radio" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" No Bias ")
const _hoisted_21 = { class: "radio" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Horizontal Bias ")
const _hoisted_23 = { class: "radio" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Vertical Bias ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AlgoNavBar = _resolveComponent("AlgoNavBar")
  const _component_SVG = _resolveComponent("SVG")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_Cell = _resolveComponent("Cell")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_AlgoNavBar, {
      algorithmsList: _ctx.pathFindingAlgorithms,
      buttonsList: _ctx.navbarButtons,
      selectedAlgo: _ctx.selectedPathFindingAlgorithm,
      onAlgorithmChanged: _ctx.setNewPathFindingAlgo,
      algoSpeed: _ctx.algorithmSpeed,
      "onUpdate:algoSpeed": _cache[1] || (_cache[1] = ($event: any) => (_ctx.algorithmSpeed = $event)),
      algoSpeedModifiers: { sync: true },
      cellSize: _ctx.CELL_SIZE,
      "onUpdate:cellSize": _cache[2] || (_cache[2] = ($event: any) => (_ctx.CELL_SIZE = $event)),
      cellSizeModifiers: { sync: true },
      showMazeDropdown: true,
      mazeGenAlgorithmsList: _ctx.mazeGenerationAlgorithms,
      onMazeGenerationAlgoSelected: _ctx.setNewMazeGenAlgo
    }, null, 8, ["algorithmsList", "buttonsList", "selectedAlgo", "onAlgorithmChanged", "algoSpeed", "cellSize", "mazeGenAlgorithmsList", "onMazeGenerationAlgoSelected"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", {
            class: "cell-info-div checkbox",
            style: { backgroundColor: _ctx.cellColors.default },
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setIsDiagonalMovementAllowed && _ctx.setIsDiagonalMovementAllowed(...args)))
          }, [
            (_ctx.diagonalMovementAllowed)
              ? (_openBlock(), _createBlock(_component_SVG, {
                  key: 0,
                  name: _ctx.svgNames.checkbox
                }, null, 8, ["name"]))
              : _createCommentVNode("", true)
          ], 4),
          _hoisted_5
        ]),
        _createVNode(_component_Tooltip, { tooltipMessage: 'The algorithm to visualize' }, {
          default: _withId(() => [
            _hoisted_6,
            _createVNode("p", null, _toDisplayString(_ctx.selectedPathFindingAlgorithm), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Tooltip, { tooltipMessage: 'Speed of the animation in milliseconds' }, {
          default: _withId(() => [
            _hoisted_7,
            _createVNode("p", null, _toDisplayString(_ctx.algorithmSpeed), 1)
          ]),
          _: 1
        }),
        _createVNode("div", null, [
          _createVNode(_component_Tooltip, {
            tooltipMessage: _ctx.TOOLTIPS.UNVISITED_NODE
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", {
                  class: "cell-info-div",
                  style: { backgroundColor: _ctx.cellColors.default }
                }, null, 4),
                _hoisted_9
              ])
            ]),
            _: 1
          }, 8, ["tooltipMessage"]),
          _createVNode(_component_Tooltip, {
            tooltipMessage: _ctx.TOOLTIPS.WALL_NODE
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", {
                  class: "cell-info-div",
                  style: { backgroundColor: _ctx.cellColors.wall }
                }, null, 4),
                _hoisted_11
              ])
            ]),
            _: 1
          }, 8, ["tooltipMessage"])
        ]),
        _createVNode("div", null, [
          _createVNode(_component_Tooltip, {
            tooltipMessage: _ctx.TOOLTIPS.OPEN_NODE
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", {
                  class: "cell-info-div",
                  style: { backgroundColor: _ctx.cellColors.open }
                }, null, 4),
                _hoisted_13
              ])
            ]),
            _: 1
          }, 8, ["tooltipMessage"]),
          _createVNode(_component_Tooltip, {
            tooltipMessage: _ctx.TOOLTIPS.CLOSED_NODE
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", {
                  class: "cell-info-div",
                  style: { backgroundColor: _ctx.cellColors.closed }
                }, null, 4),
                _hoisted_15
              ])
            ]),
            _: 1
          }, 8, ["tooltipMessage"])
        ]),
        _createVNode("div", null, [
          _createVNode(_component_Tooltip, {
            tooltipMessage: _ctx.TOOLTIPS.FINAL_PATH
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_16, [
                _createVNode("div", {
                  class: "cell-info-div",
                  style: { backgroundColor: _ctx.cellColors.path }
                }, null, 4),
                _hoisted_17
              ])
            ]),
            _: 1
          }, 8, ["tooltipMessage"])
        ])
      ]),
      (
                    _ctx.selectedMazeGenerationAlgorithm ===
                    _ctx.allMazeGenerationAlgorithms.RECURSIVE_DIVISION
                )
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _createVNode("label", _hoisted_19, [
              _createVNode("input", {
                type: "radio",
                name: "maze-bias",
                checked: "",
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeMazeBias('none')))
              }, null, 32),
              _hoisted_20
            ]),
            _createVNode("label", _hoisted_21, [
              _createVNode("input", {
                type: "radio",
                name: "maze-bias",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeMazeBias('horizontal')))
              }, null, 32),
              _hoisted_22
            ]),
            _createVNode("label", _hoisted_23, [
              _createVNode("input", {
                type: "radio",
                name: "maze-bias",
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeMazeBias('vertical')))
              }, null, 32),
              _hoisted_24
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: "grid-container",
        id: "grid-container",
        onDragover: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nodeDragOver && _ctx.nodeDragOver(...args)))
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.matrix, (row, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: "is-flex"
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(row, (col, idx) => {
              return (_openBlock(), _createBlock(_component_Cell, {
                key: `${index}-${idx}`,
                cell: _ctx.matrix[index][idx],
                isStartNode: _ctx.matrix[index][idx] === _ctx.startNode,
                isEndNode: _ctx.matrix[index][idx] === _ctx.endNode,
                cellSize: _ctx.CELL_SIZE,
                onClicked: _ctx.cellClick,
                onNodeDropped: _ctx.nodeDropped,
                onNodeDragStart: _ctx.nodeDragStart,
                isMouseDown: _ctx.mouseDown
              }, null, 8, ["cell", "isStartNode", "isEndNode", "cellSize", "onClicked", "onNodeDropped", "onNodeDragStart", "isMouseDown"]))
            }), 128))
          ]))
        }), 128))
      ], 32)
    ], 512)
  ]))
})